import "vanilla-cookieconsent/dist/cookieconsent";
import "./css/style.css"

export default new class AnyCookieConsent {

	config = {
		btnColor: "#2d4156",
		darkMode: false
	};

	/**
	 * @public
	 */
	init(config = {}) {
		var conf = {...this.config, ...config};
		window.addEventListener("load", function () {
			if (conf.darkMode) {
				document.body.classList.toggle('c_darkmode');
			}
			document.body.style.setProperty("--cc-btn-primary-bg", conf.btnColor)
			let lang = document.documentElement.lang !== "" ? document.documentElement.lang : "cs";
			let cc = initCookieConsent();
			cc.run({
				current_lang     : lang,
				autoclear_cookies: true,
				page_scripts     : true,
				gui_options      : {
					consent_modal: {
						layout    : 'cloud',
						transition: 'slide'
					},
				},

				languages: {
					'cs': {
						consent_modal : {
							title        : 'Používáme soubory cookies',
							description  : 'Tyto webové stránky používají soubory cookies a další sledovací nástroje s cílem vylepšení uživatelského prostředí, zobrazení přizpůsobeného obsahu a reklam, analýzy návštěvnosti webových stránek a zjištění zdroje návštěvnosti.',
							primary_btn  : {
								text: 'Přijmout vše',
								role: 'accept_all' // 'accept_selected' or 'accept_all'
							},
							secondary_btn: {
								text: 'Spravovat cookies',
								role: 'settings' // 'settings' or 'accept_necessary'
							}
						},
						settings_modal: {
							title               : 'Centrum předvoleb souborů Cookies',
							save_settings_btn   : 'Uložit nastavení',
							accept_all_btn      : 'Přijmout vše',
							reject_all_btn      : 'Pouze nezbytné cookies',
							close_btn_label     : 'Zavřít',
							cookie_table_headers: [
								{col1: 'Název'},
								{col2: 'Doména'},
								{col3: 'Platnost do'},
								{col4: 'Popis'}
							],
							blocks              : [
								{
									title      : 'Vaše soukromí je pro nás důležité',
									description: 'Soubory cookies jsou velmi malé textové soubory, které se ukládají do vašeho zařízení při navštěvování webových stránek. Soubory Cookies používáme pro různé účely a pro vylepšení vašeho online zážitku na webové stránce (například pro zapamatování přihlašovacích údajů k vašemu účtu). Při procházení našich webových stránek můžete změnit své předvolby a odmítnout určité typy cookies, které se mají ukládat do vašeho počítače. Můžete také odstranit všechny soubory cookie, které jsou již uloženy ve vašem počítači, ale mějte na paměti, že odstranění souborů cookie vám může zabránit v používání částí našeho webu.'
								}, {
									title      : 'Bezpodmínečně nutné soubory cookies',
									description: 'Tyto soubory cookies jsou nezbytné k tomu, abychom vám mohli poskytovat služby dostupné prostřednictvím našeho webu a abychom vám umožnili používat určité funkce našeho webu. Bez těchto cookies vám nemůžeme na naší webové stránce poskytovat určité služby.',
									toggle     : {
										value   : 'necessary',
										enabled : true,
										readonly: true          // cookie categories with readonly=true are all treated as "necessary cookies"
									}
								}, {
									title      : 'Sledovací a výkonnostní soubory cookies',
									description: 'Tyto soubory cookies se používají ke shromažďování informací pro analýzu provozu na našich webových stránkách a sledování používání našich webových stránek uživateli. Tyto soubory cookies mohou například sledovat věci jako je doba kterou na webu trávíte, nebo stránky, které navštěvujete, což nám pomáhá pochopit, jak pro vás můžeme vylepšit náš web. Informace shromážděné prostřednictvím těchto sledovacích a výkonnostních cookies neidentifikují žádné osoby.',
									toggle     : {
										value   : 'analytics',     // your cookie category
										enabled : false,
										readonly: false
									},
								}, {
									title      : 'Cookies pro cílení a reklamu',
									description: 'Tyto soubory cookie se používají k zobrazování reklamy, která vás pravděpodobně bude zajímat na základě vašich zvyků při procházení. Tyto soubory cookie, jsou požadovány námi/nebo poskytovateli reklam, mohou kombinovat informace shromážděné z našich webových stránek s dalšími informacemi, které nezávisle shromáždily z jiných webových stránek, týkající se činností vašeho internetového prohlížeče v rámci jejich reklamní sítě webových stránek. Pokud se rozhodnete tyto soubory cookies pro cílení nebo reklamu odstranit nebo deaktivovat, budou se vám reklamy stále zobrazovat, ale nemusí pro vás být nadále personalizované a relevantní.',
									toggle     : {
										value   : 'targeting',
										enabled : false,
										readonly: false
									}
								}, {
									title      : 'Další informace',
									description: 'V případě jakýchkoliv dotazů ohledně našich zásad týkajících se souborů cookie a vašich možností nás prosím kontaktujte.',
								}
							]
						}
					},
					'en': {
						consent_modal : {
							title        : 'We use cookies!',
							description  : 'Hi, this website uses essential cookies to ensure its proper operation and tracking cookies to understand how you interact with it. The latter will be set only after consent. <button type="button" data-cc="c-settings" class="cc-link">Let me choose</button>',
							primary_btn  : {
								text: 'Accept all',
								role: 'accept_all'              // 'accept_selected' or 'accept_all'
							},
							secondary_btn: {
								text: 'Reject all',
								role: 'accept_necessary'        // 'settings' or 'accept_necessary'
							}
						},
						settings_modal: {
							title               : 'Cookie preferences',
							save_settings_btn   : 'Save settings',
							accept_all_btn      : 'Accept all',
							reject_all_btn      : 'Reject all',
							close_btn_label     : 'Close',
							cookie_table_headers: [
								{col1: 'Name'},
								{col2: 'Domain'},
								{col3: 'Expiration'},
								{col4: 'Description'}
							],
							blocks              : [
								{
									title      : 'Cookie usage 📢',
									description: 'I use cookies to ensure the basic functionalities of the website and to enhance your online experience. You can choose for each category to opt-in/out whenever you want. For more details relative to cookies and other sensitive data, please read the full <a href="#" class="cc-link">privacy policy</a>.'
								}, {
									title      : 'Strictly necessary cookies',
									description: 'These cookies are essential for the proper functioning of my website. Without these cookies, the website would not work properly',
									toggle     : {
										value   : 'necessary',
										enabled : true,
										readonly: true          // cookie categories with readonly=true are all treated as "necessary cookies"
									}
								}, {
									title       : 'Performance and Analytics cookies',
									description : 'These cookies allow the website to remember the choices you have made in the past',
									toggle      : {
										value   : 'analytics',     // your cookie category
										enabled : false,
										readonly: false
									},
									cookie_table: [             // list of all expected cookies
										{
											col1    : '^_ga',       // match all cookies starting with "_ga"
											col2    : 'google.com',
											col3    : '2 years',
											col4    : 'description ...',
											is_regex: true
										},
										{
											col1: '_gid',
											col2: 'google.com',
											col3: '1 day',
											col4: 'description ...',
										}
									]
								}, {
									title      : 'Advertisement and Targeting cookies',
									description: 'These cookies collect information about how you use the website, which pages you visited and which links you clicked on. All of the data is anonymized and cannot be used to identify you',
									toggle     : {
										value   : 'targeting',
										enabled : false,
										readonly: false
									}
								}, {
									title      : 'More information',
									description: 'For any queries in relation to our policy on cookies and your choices, please <a class="cc-link" href="#yourcontactpage">contact us</a>.',
								}
							]
						}
					},
					'sk': {
						consent_modal : {
							title        : 'Používame súbory cookies',
							description  : 'Tieto webové stránky používajú súbory cookies a ďalšie sledovacie nástroje s cieľom vylepšenia uživateľského prostredia, zobrazenia prispôsobeného obsahu a reklám, analýzy návštevnosti webových stránok a zistenia zdroja návštevnosti.',
							primary_btn  : {
								text: 'Prijať všetko',
								role: 'accept_all' // 'accept_selected' or 'accept_all'
							},
							secondary_btn: {
								text: 'Nastavenia cookies',
								role: 'settings' // 'settings' or 'accept_necessary'
							}
						},
						settings_modal: {
							title               : 'Centrum predvolieb súborov Cookies',
							save_settings_btn   : 'Uložiť nastavenia',
							accept_all_btn      : 'Prijať všetko',
							reject_all_btn      : 'Iba povinné cookies',
							close_btn_label     : 'Zatvoriť',
							cookie_table_headers: [
								{col1: 'Názov'},
								{col2: 'Doména'},
								{col3: 'Platnosť do'},
								{col4: 'Popis'}
							],
							blocks              : [
								{
									title      : 'Vaše súkromie je pre nás dôležité',
									description: 'Súbory cookies sú veľmi malé textové soubory, ktoré sa ukladajú do Vášho zariadenia pri navštevovaní webových stránok. Súbory Cookies používame pre rôzne účely a pre zlepšenie Vášho online zážitku na webovej stránke (napríklad pre zapamätanie prihlasovacích údajov k Vášmu účtu). Pri prechádzaní našich webových stránok môžete zmenit svoje predvoľby a odmietnuť určité typy cookies, ktoré sa majú ukladať do Vášho počítača. Môžete tiež odstrániť všetky súbory cookie, ktoré sú už uložené vo Vašom počítači, ale majte na pamäti, že odstranenie súborov cookie Vám môže zabrániť v používání části našeho webu.'
								}, {
									title      : 'Bezpodmienečné nutné súbory cookies',
									description: 'Tieto súbory cookies sú nevyhnutné k tomu, aby sme Vám mohli poskytovať služby dostupné prostrednictvom nášho webu a aby sme Vám umožnili používať určité funkcie nášho webu. Bez týchto cookies Vám nemôžeme na našej webovej stránke poskytovať určité služby.',
									toggle     : {
										value   : 'necessary',
										enabled : true,
										readonly: true          // cookie categories with readonly=true are all treated as "necessary cookies"
									}
								}, {
									title      : 'Sledovacie a výkonnostné súbory cookies',
									description: 'Tieto súbory cookies sa používajú k zhromažďovaniu informácií pre analýzu prevádzky na našich webových strankách a sledovanie použavania našich webových stránok uživateľmi. Tieto súbory cookies môžu napríklad sledovať veci ako je doba, ktorú na webe trávite, alebo stránky, ktoré navštevujete, čo nám pomáha pochopiť, ako pre Vás môžeme vylepšiť náš web. Informácie zhromaždené prostredníctvom týchto sledovacích a výkonnostných cookies neidentifikujú žiadne osoby.',
									toggle     : {
										value   : 'analytics',     // your cookie category
										enabled : false,
										readonly: false
									},
								}, {
									title      : 'Cookies pro cielenie a reklamu',
									description: 'Tieto súbory cookie sa používajú k zobrazovaniu reklamy, ktorá Vás pravdepodobne bude zaujímať na základe Vašich zvykov pri prechádzaní webu. Tieto súbory cookie sú požadované nami alebo poskytovateľmi reklám, môžu kombinovať informácie zhromaždené z našich webových stránok s ďalšími informáciami, ktoré nezávisle zhromaždili z iných webových stránok, týkajúcich sa činnosti Vášho internetového prehliadača v rámci ich reklamnej siete webových stránok. Ak sa rozhodnete tieto súbory cookies pre cielenie alebo reklamu odstrániť alebo deaktivovať, budú sa Vám reklamy stále zobrazovať, ale nemusia pre Vás byť ďalej personalizované a relevantné.',
									toggle     : {
										value   : 'targeting',
										enabled : false,
										readonly: false
									}
								}, {
									title      : 'Ďalšie informácie',
									description: 'V prípade akýchkoľvek otázok ohľadom našich zásad, týkajúcich sa súborov cookie a Vašich možností, nás prosím kontaktujte.',
								}
							]
						}
					},
				},
				'sk'     : {
					consent_modal : {
						title        : 'Používame súbory cookies',
						description  : 'Tieto webové stránky používajú súbory cookies a ďalšie sledovacie nástroje s cieľom vylepšenia uživateľského prostredia, zobrazenia prispôsobeného obsahu a reklám, analýzy návštevnosti webových stránok a zistenia zdroja návštevnosti.',
						primary_btn  : {
							text: 'Prijať všetko',
							role: 'accept_all' // 'accept_selected' or 'accept_all'
						},
						secondary_btn: {
							text: 'Nastavenia cookies',
							role: 'settings' // 'settings' or 'accept_necessary'
						}
					},
					settings_modal: {
						title               : 'Centrum predvolieb súborov Cookies',
						save_settings_btn   : 'Uložiť nastavenia',
						accept_all_btn      : 'Prijať všetko',
						reject_all_btn      : 'Iba povinné cookies',
						close_btn_label     : 'Zatvoriť',
						cookie_table_headers: [
							{col1: 'Názov'},
							{col2: 'Doména'},
							{col3: 'Platnosť do'},
							{col4: 'Popis'}
						],
						blocks              : [
							{
								title      : 'Vaše súkromie je pre nás dôležité',
								description: 'Súbory cookies sú veľmi malé textové soubory, ktoré sa ukladajú do Vášho zariadenia pri navštevovaní webových stránok. Súbory Cookies používame pre rôzne účely a pre zlepšenie Vášho online zážitku na webovej stránke (napríklad pre zapamätanie prihlasovacích údajov k Vášmu účtu). Pri prechádzaní našich webových stránok môžete zmenit svoje predvoľby a odmietnuť určité typy cookies, ktoré sa majú ukladať do Vášho počítača. Môžete tiež odstrániť všetky súbory cookie, ktoré sú už uložené vo Vašom počítači, ale majte na pamäti, že odstranenie súborov cookie Vám môže zabrániť v používání části našeho webu.'
							}, {
								title      : 'Bezpodmienečné nutné súbory cookies',
								description: 'Tieto súbory cookies sú nevyhnutné k tomu, aby sme Vám mohli poskytovať služby dostupné prostrednictvom nášho webu a aby sme Vám umožnili používať určité funkcie nášho webu. Bez týchto cookies Vám nemôžeme na našej webovej stránke poskytovať určité služby.',
								toggle     : {
									value   : 'necessary',
									enabled : true,
									readonly: true          // cookie categories with readonly=true are all treated as "necessary cookies"
								}
							}, {
								title      : 'Sledovacie a výkonnostné súbory cookies',
								description: 'Tieto súbory cookies sa používajú k zhromažďovaniu informácií pre analýzu prevádzky na našich webových strankách a sledovanie použavania našich webových stránok uživateľmi. Tieto súbory cookies môžu napríklad sledovať veci ako je doba, ktorú na webe trávite, alebo stránky, ktoré navštevujete, čo nám pomáha pochopiť, ako pre Vás môžeme vylepšiť náš web. Informácie zhromaždené prostredníctvom týchto sledovacích a výkonnostných cookies neidentifikujú žiadne osoby.',
								toggle     : {
									value   : 'analytics',     // your cookie category
									enabled : false,
									readonly: false
								},
							}, {
								title      : 'Cookies pre cielenie a reklamu',
								description: 'Tieto súbory cookie sa používajú k zobrazovaniu reklamy, ktorá Vás pravdepodobne bude zaujímať na základe Vašich zvykov pri prechádzaní webu. Tieto súbory cookie sú požadované nami alebo poskytovateľmi reklám, môžu kombinovať informácie zhromaždené z našich webových stránok s ďalšími informáciami, ktoré nezávisle zhromaždili z iných webových stránok, týkajúcich sa činnosti Vášho internetového prehliadača v rámci ich reklamnej siete webových stránok. Ak sa rozhodnete tieto súbory cookies pre cielenie alebo reklamu odstrániť alebo deaktivovať, budú sa Vám reklamy stále zobrazovať, ale nemusia pre Vás byť ďalej personalizované a relevantné.',
								toggle     : {
									value   : 'targeting',
									enabled : false,
									readonly: false
								}
							}, {
								title      : 'Ďalšie informácie',
								description: 'V prípade akýchkoľvek otázok ohľadom našich zásad, týkajúcich sa súborov cookie a Vašich možností, nás prosím kontaktujte.',
							}
						]
					}
				},
			});
		})

	}
}


// WEBPACK FOOTER //
// ./node_modules/@anything-studio/any-cookie-consent/src/index.js